import {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { type DigitRowContextType, type DigitRowProviderProps } from "./digit.interface";

const DigitRowContext = createContext<DigitRowContextType | undefined>(
  undefined,
);

const useDigitRowContext = () => {
  const context = useContext(DigitRowContext);
  if (context === undefined) {
    throw new Error(
      "useDigitRowContext must be used within a DigitRowProvider",
    );
  }
  return context;
};

function DigitRowProvider ({ children, onChange }:DigitRowProviderProps) {
  const [digits, setDigits] = useState<string[]>(["", "", "", "", "", "", "", ""]);

  const setDigit = (index: number, value: string, upperCase?: boolean) => {
    const newDigits = [...digits];

    if (value && upperCase) {
      newDigits[index] = value.toUpperCase();
    } else if (value && upperCase === false) {
     newDigits[index] = value.toLowerCase();
    } else {
      newDigits[index] = value;
    }

    setDigits(newDigits);
  };

  const setValue = (values: string, upperCase?: boolean) => {

    if (values && upperCase) {
      setDigits(values.toUpperCase().split(""));
    } else if (values && upperCase === false) {
      setDigits(values.toLowerCase().split(""));
    } else {
      const newDigits = values.split("");
      setDigits(newDigits);
    }
  };

  useEffect(() => {

    const digitsText = digits.join("");
    console.log("Digits text: ", digitsText);
    onChange(digitsText);


  }, [digits, onChange]);

  return (
    <DigitRowContext.Provider
      value={{
        digits,
        setDigit,
        setValue,
      }}
    >
      {children}
    </DigitRowContext.Provider>
  );
}

export { DigitRowProvider, useDigitRowContext };
